// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1d2ZG","fileBtn":"File_fileBtn__3Bv3E","closeBtn":"File_closeBtn__24tBC","fileSelected":"File_fileSelected__11PLQ","disabled":"File_disabled__1MuFJ"};